import { isArray, cloneDeep } from 'lodash'

export function sanitize(value: string): string {
  return value.replace(/\n/g, '\\n').replace(/"/g, '""')
}

export function revertSanitize(value?: string): string | undefined {
  if (!value) {
    return value
  }

  return value.replace(/\\n/g, '\n').replace(/\\r/g, '\r').replace(/""/g, '"')
}

export function sanitizeText<V extends string | undefined>(value?: V): V {
  if (!value) {
    return value as V
  }

  if (typeof value !== 'string') {
    return value
  }

  return trim(value) as V
}

export function sanitizeTextArray(value?: string[]): string[] | undefined {
  if (!Array.isArray(value)) {
    return
  }

  return value.reduce((output: string[], item: string) => {
    output.push(trim(item))
    return output
  }, [])
}

function trim(value: string): string {
  if (typeof value !== 'string') {
    return value
  }

  return value.trim()
}

export function getSanitizedTextCopy(value?: string | string[]): string | string[] | undefined {
  const copy = cloneDeep(value)
  return isArray(copy) ? sanitizeTextArray(copy) : sanitizeText(copy)
}
